const componentSerializationKey_oldPlatsa = 'PlatsaTopComponent'; // This component was previously PLATSA specific with this serializationKey
const componentSerializationKey = 'TopComponent';
/**
 * This component should be added to the frame and signals that
 * the user has done an active choise if frame should have top or
 * not so the TopPanelSystem doesn't change that.
 */
export class FrameTopComponentSerializer {
    constructor() {
        this.thisClassIsGuaranteedToNotModifyOrQueryCoreState = true;
    }
    canHandle(serializationKey) {
        return (serializationKey === componentSerializationKey ||
            serializationKey === componentSerializationKey_oldPlatsa);
    }
    deserialize(serializationKey) {
        switch (serializationKey) {
            case componentSerializationKey:
            case componentSerializationKey_oldPlatsa:
                return new FrameTopComponent();
        }
        return null;
    }
}
class FrameTopComponent {
    constructor() {
        this.typeId = FrameTopComponent.id;
        this.doStoreInSnapshot = true;
        this.serializable = true;
    }
    serializationKey() {
        return componentSerializationKey;
    }
    toJson(parse) {
        return parse(JSON.stringify(this));
    }
    eq() {
        return true;
    }
}
FrameTopComponent.id = 2044;
export default FrameTopComponent;
//# sourceMappingURL=FrameTopComponent.js.map